import * as React from "react";

const COMPONENT_CDN = process.env.COMPONENT_CDN || "";
export const hrefToComponentStyles = `${COMPONENT_CDN}/global.css`;

type WithComponentStylesProps = {
  children?: React.ReactNode;
};

export const WithComponentStyles: React.FC<WithComponentStylesProps> = ({
  children,
}) => (
  <>
    <link rel="stylesheet" href={hrefToComponentStyles}></link>
    <div className="duffel-components">{children}</div>
  </>
);
;
import "/Users/igordepaula/.yarn/berry/cache/@sentry-bundler-plugin-core-npm-0.7.2-054e3436fd-10c0.zip/node_modules/@sentry/bundler-plugin-core/sentry-release-injection-file.js";